<template>
    <div
        class="flex flex-wrap sm:gap-3 flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:justify-between w-full px-4 mb-2 mt-4 items-center">
        <div class="mr-auto sm:justify-start">
            <button @click="segundoCargueMasivo()"
                class="px-4 py-2 text-white bg-blue-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="inline-block w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                </svg>
                <span class="ml-3">Segundo Cargue SIAFF</span>
            </button>
        </div>
    </div>
    <!--  CARGUE MASIVO-->
    <div class="hidden">
        <div class="max-w-xl" id="segundo_cargue_masivo_siaff">
            <a type="button" :href="`${baseUrl}/assets/reservas/Plantilla_Segundo_Cargue_Reserva_Presupuestal.xlsx`" download="Plantilla_Segundo_Cargue_Reserva_Presupuestal.xlsx"
                class="rounded-md border my-3 mr-3 float-right border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:putline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="text-white self-center w-6 h-6 inline-block text-gray-600"
                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>
                <span class="ml-3">Plantilla 2do Cargue</span>
            </a>
            <span class="ml-3 font-medium text-gray-600 grow">Fase II - Proceso de Cargue SIAFF</span>
            <label style="min-height: 8rem;" for="archivo_segundo_cargue"
                class="flex justify-center w-full transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
                <span ref="fileFormEnter" id="contenedor_archivo_segundo_cargue" class="flex items-center space-x-2 w-full">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600 grow" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                    <span class="font-medium text-gray-600 grow">
                        Arrastra el archivo aquí, o
                        <span class="text-blue-600 underline">abre el explorador</span>
                    </span>
                </span>
                <span ref="fileFormDrop" id="drag_over_segundo_cargue" class="hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600 grow"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                    </svg>
                </span>
                <span ref="fileFormUploaded" id="info_archivo_segundo_cargue" class="hidden">
                    <img id="preview_archivo_segundo_cargue" src="" alt="" />
                    <span class="flex justify-center align-middle gap-3">
                        <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                        </svg>
                        <span id="nombre_archivo_segundo_cargue" class="self-center"></span>
                    </span>
                </span>
                <input type="file" id="archivo_segundo_cargue"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
                    class="hidden" @change="
                        uploadFile(document.getElementById('archivo_segundo_cargue').files.item(0), '_segundo_cargue');
                    file = document.getElementById('archivo_segundo_cargue').files.item(0);">

            </label>
        </div>
    </div>
</template>
  
<script>
import {
    enableUploadFileByDragger,
    generateTextError,
    removeFile,
    swal,
    uploadFile,
    useAPIRest,
    verifyHttpCode,
} from "@/common/constants";

export default {
    name: 'ReservasSegundoCargueComponent',
    emits: ["updateValues"],
    props: ['authToken', 'mainListCollectionData', 'selectedData'],
    data: function () {
        return {
            document: document,
            uploadFile: uploadFile,
            alertCargueMasivo: '',
            file: undefined,
            baseUrl: window.location.origin,
        }
    },
    methods: {
        /**
         * Limpia el archivo cargado y el mensaje de alerta del cargue masivo.
         */
        limpiarCargueMasivo: function () {
            removeFile(this.alertCargueMasivo, '_segundo_cargue');
            this.file = undefined;
        },
        /**
         Carga un archivo de forma masiva y muestra una alerta de confirmación.
         @async
         @function
         @name segundoCargueMasivo
         @memberof methods
         @returns {Promise} - Promesa que resuelve con el resultado de la carga masiva.
         */
        segundoCargueMasivo: async function () {
            if (!this.alertCargueMasivo) {
                this.alertCargueMasivo = document.getElementById('segundo_cargue_masivo_siaff');
                document.getElementById('segundo_cargue_masivo_siaff').remove();
            }
            await swal.fire({
                html: this.alertCargueMasivo,
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Cargar archivo',
                customClass: {
                    actions: 'm-0'
                },
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    const archivoCargado = this.file;
                    const id_cargue_siaff = this.selectedData.id;
                    if (archivoCargado) {
                        const extenciones_excel_validas = ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
                        if (extenciones_excel_validas.includes(archivoCargado.type)) {
                            const formData = new FormData();
                            formData.append('file', archivoCargado, archivoCargado.name);
                            formData.append('id_cargue_siaff', id_cargue_siaff);
                            formData.append('estado', 2);
                            return await useAPIRest(process.env.VUE_APP_NEST_PASIVOEXIGIBLETEMP_SEGUNDOCARGUE, 'POST', this.authToken, formData, undefined, 'auto').then(async resJSON => resJSON);
                        } else await swal.fire('¡Solo se admiten archivos Excel con el formato .xls, xlsx o .csv!', '', 'error');
                    } else await swal.fire('¡No se cargo ningun archivo!', '', 'error');
                },
                allowOutsideClick: () => !swal.isLoading()
            }).then(async (result) => {
                if (result.isConfirmed && result.value !== true) {
                    const resJSON = result.value;
                    const { statusCode } = resJSON;
                    delete resJSON['statusCode'];
                    const textoError = generateTextError(resJSON);
                    if (verifyHttpCode(statusCode, 'success')) {
                        await swal.fire('Cargue masivo realizado con exito', '', 'success');
                        this.$emit('updateValues', {
                            'estado_cargue': parseInt(resJSON.estado_cargue)
                        })
                    }
                    else {
                        if (textoError.search('\n') !== -1)
                            await swal.fire({
                                title: 'Cargue masivo realizado con errores',
                                icon: 'error',
                                focusConfirm: true,
                                confirmButtonText: '¡Descargar informe de errores!'
                            }).then(() => {
                                const element = document.createElement('a');
                                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(textoError));
                                element.setAttribute('download', 'informe_de_errores_cargue_masivo');
                                element.style.display = 'none';
                                document.body.appendChild(element);
                                element.click();
                                document.body.removeChild(element);
                            });
                        else await swal.fire(textoError, '', 'error');
                    }
                }
            });
            this.limpiarCargueMasivo();
            this.mainListCollectionData();
        }
    },
    watch: {
        "file": function (file) {
            if (file && window.navigator.userAgent.includes("Firefox")) {
                const name = file.name;
                const mimeType = file.type;
                const lastDot = name.lastIndexOf('.');
                const fileName = name.substring(0, lastDot);
                const ext = name.substring(lastDot + 1);
                if (ext === 'csv' && mimeType !== 'text/csv') this.file = new File([file], `${fileName}.${ext}`, { type: 'text/csv' });
            }
        }
    },
    mounted() {

        enableUploadFileByDragger(this);
    }
}
</script>